export class HsTextureData {
  constructor(public buffer: ArrayBufferLike, public width: number, public height: number, public byteLength: number) {}
}
